module.exports = __webpack_public_path__ + "static/gangplank-bald.9b0922da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gangplank-bald.jpg
// module id = 514
// module chunks = 35783957827783